/**
 *
 * manage followup Page
 *
 */
import Select from "react-select"
import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import PropTypes from "prop-types"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Badge,
  Spinner,
  Table,
} from "reactstrap"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import { useSelector, useDispatch } from "react-redux"
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
// dispatch actions
import * as manageFollowupAction from "../../store/bWFuYWdlRm9sbG93/actions"
import { isEmpty } from "lodash"
//Import Styles
import "./styles.scss"
import * as auditAction from "../../store/c2FsZXNG/actions"
import ButtonSpinner from "../../components/ButtonSpinner"
//date format
import moment from "moment"
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ToastContainer, toast } from "react-toastify"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import api from "helpers/Api"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
//import { Slider, InputNumber } from 'antd'

const ManageFollowup = (props) => {
  const title = "Manage Followup"

  const { dispatch, searchBtnStyle } = props
  const specificDispatch = useDispatch()
  const [applyFilter, setApplyFilter] = useState(false)
  const [downloadLoading, setDownloadLoading] = useState(false)
  useEffect(() => {
    dispatch(manageFollowupAction.loadRecordsMetaData())
    dispatch(
      manageFollowupAction.loadManageFollowupList({
        page: 1,
        limit: 50,
      })
    )
    setApplyFilter(false)
  }, [])

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.manageFollowup
  )
  const {
    manageFollowupMetaData = {},
    followup_details = [],
    assign_details = [],
  } = permissionUpdate


  // Date format
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate
  const authUser = localStorage.getItem("authUser")

  const responseLogin = JSON.parse(authUser)

  //Date format
  const dateSetting =
    !isEmpty(responseLogin) &&
      responseLogin.setting &&
      responseLogin.setting.dateFormate
      ? responseLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""
  const seasonDates = !isEmpty(manageFollowupMetaData) && manageFollowupMetaData.seasonOptions.map(m => m.label)
  const seasonDateFlat = !isEmpty(seasonDates) && seasonDates.flatMap(m => m)
  const seasonDateValue = !isEmpty(seasonDateFlat) && seasonDateFlat.map(m => moment(m).format(dateFormate))
  const seasonCompanys = !isEmpty(manageFollowupMetaData) && manageFollowupMetaData.seasonOptions.map(m => m.companyId)
  const companySeasonFlat = !isEmpty(seasonCompanys) && seasonCompanys.flatMap(m => m)
  const companySeasonId = !isEmpty(companySeasonFlat) && companySeasonFlat.filter((item, index) => companySeasonFlat.indexOf(item) === index)

  //range value
  // const [isRange, setIsRange] = useState(false)
  // const [rangeValue, setRangeValue] = useState([1, 1000000])
  // const handleRangeChange = (val) => {
  //   setRangeValue(val)
  //   setIsRange(true)
  // }


  // // Handle the min value change
  // const handleMinChange = (newMin) => {
  //   const newRange = [newMin, rangeValue[1]]
  //   if (newMin > rangeValue[1]) {
  //     setRangeValue([newMin, newMin])
  //     setIsRange(true)
  //   } else {
  //     setRangeValue(newRange)
  //     setIsRange(true)
  //   }
  // }

  // // Handle the max value change
  // const handleMaxChange = (newMax) => {
  //   const newRange = [rangeValue[0], newMax]
  //   if (newMax < rangeValue[0]) {
  //     setRangeValue([newMax, newMax])
  //     setIsRange(true)
  //   } else {
  //     setRangeValue(newRange)
  //     setIsRange(true)
  //   }
  // }
//   //Access for download

//   const loginAccess = !isEmpty(user) && user ? user : []
 
//   const followupMenu =
//     !isEmpty(loginAccess) && loginAccess.menu
//       ? loginAccess.menu.filter(
//         (menu) => menu.menuId._id === "623854fcf73a35e88bb021b6"
//       )
//       : []
//     console.log(followupMenu,"followupMenu")
// // 
// //"63b666ad9d129dc7b186fdf5"
//   const menuId =
//     !isEmpty(followupMenu) && followupMenu.length > 0
//       ? followupMenu.map((menu) => menu.menuId.menuSubHeader)
//       : []
//       console.log( menuId,"menuId")
//   const accessId =
//     !isEmpty(menuId) && menuId.length > 0
//       ? menuId[0].filter(
//         (data) =>
//           data._id ==="63aaa4e59ca02cc299d9fd9f" ||
//         data._id==="63b666ad9d129dc7b186fdf5"
//       ) 
//       : []
//       console.log(accessId,"accessId")
//   const accessDetails =
//     !isEmpty(accessId) && accessId.length > 0
//       ? accessId.map((menu) => menu.access)
//       : []
//       console.log(accessDetails,"accessDetails")
//   const downloadAccess =
//     !isEmpty(accessDetails) && accessDetails.length > 0
//       ? accessDetails[0].filter(
//         (data) => data.accessName == "Download" && data.accessName != undefined &&
//           data._id === "61bc3079e2e60e9919697604"
//       )
//       : []
//       console.log(downloadAccess,"downloadAccess")
     
     
//   //_id
//   const downloadAccessId =
//     !isEmpty(downloadAccess) && downloadAccess.length > 0
//       ? downloadAccess[0]._id
//       : []
//       console.log(downloadAccessId,"downloadAccessId")
  //Access section end

  const [btnLoader, setBtnLoader] = useState(false)
  const [followupData, setFollowupData] = useState({
    company: [],
    branch: [],
    department: [],
    employeeCode: [],
    fromDate: "",
    toDate: "",
    leadNo:""
  })
  const [salesAgent, setSalesAgent ] = useState([])
  const fuseAgentOptions = {
    keys: ["empCode", "label"],
  }
  //dropdown list
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [followupMode, setFollowupMode] = useState([])
  const [priorityCode, setPriorityCode] = useState([])
  const [clientStatus, setClientStatus] = useState([])
  const [isPremium, setIsPremium] = useState("")
  const [venueName, setVenueName] = useState([])
  //dropdown options api
  const branchOptions =
    !isEmpty(manageFollowupMetaData) &&
    manageFollowupMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  const statusList = [
    {
      label: "Is Premium",
      value: true,
    },
  ]
  const [agingModal, setAgingModal] = useState(false)

  const handleStatusChange = async (e, value) => {
    let isChecked = e.target.checked

    if (isChecked) {
      setIsPremium(value)
      // setAuditChecked(true)
    } else {
      setIsPremium(false)
    }
  }

  //checking
  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const priority =
    !isEmpty(priorityCode) && priorityCode.map((priority) => priority.value)

  const handleChange = async (e) => {
    setFollowupData({ ...followupData, [e.target.name]: e.target.value })
  }

  const [pageCount, setPageCount] = useState(false)
  const [btnLoading, setBtnLoading] = useState(false)
  const [pageChange, setPageChange] = useState(false)

  const clientStatusValue = clientStatus && clientStatus.map((m) => m.value)
  //Apply filter
  const handleFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchFollowup = followupMode && followupMode ? followupMode.value : ""
    var searchPriority = priorityCode && priorityCode ? priority : ""
    var searchFromDate =
      followupData && followupData.fromDate
        ? moment(followupData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      followupData && followupData.toDate
        ? moment(followupData.toDate).format("YYYY-MM-DD")
        : ""
    var searchVenue = venueName && venueName.value ? venueName.value : ""
    var searchPremium = isPremium == true ? true : false
    var searchClientStatus = !isEmpty(clientStatus) ? clientStatusValue : ""
    // var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
    // var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
    var searchLeadNo =
    followupData && followupData.leadNo
      ? followupData.leadNo
      : ""
    var searchAgent = !isEmpty(salesAgent) && salesAgent ? salesAgent.value : ""
    var searchvalue = {}
    searchvalue.page = pageChange ? pageCount : 1
    searchvalue.limit = sizePerPage ? sizePerPage : 50
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchPremium) {
      searchvalue.isPremium = searchPremium
    }

    if (searchVenue) {
      searchvalue.venueId = searchVenue
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchFollowup) {
      searchvalue.mode = searchFollowup
    }
    if (searchPriority) {
      searchvalue.priorityId = searchPriority
    }
    if (searchClientStatus) {
      searchvalue.clientStatus = searchClientStatus
    }
    if (searchFromDate) {
      searchvalue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.toDate = searchToDate
    }
    if (searchClientStatus) {
      searchvalue.profileStatus = searchClientStatus
    }
    if (searchLeadNo) {
      searchvalue.leadNo = searchLeadNo
    }
    if (searchAgent) {
      searchvalue.salesAgentId  = searchAgent
    }
    // if (isRange) {
    //   if (searchFromRange) {
    //     searchvalue.fromRange = searchFromRange
    //   }
    //   if (searchToRange) {
    //     searchvalue.toRange = searchToRange
    //   }
    // }
    setPageLoad(!pageLoad)

    specificDispatch(manageFollowupAction.loadManageFollowupList(searchvalue))
    setBtnLoader(true)
    setBtnLoading(true)
    setApplyFilter(true)
    setTimeout(() => {
      setBtnLoading(false)
      setBtnLoader(false)
    }, 2000)
  }
  const today = moment().format("YYYY-MM-DD")
  //reset functionalities
  const [agentKey, setAgentKey] = useState(false)

  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setFollowupMode([])
    setPriorityCode([])
    setClientStatus([])
    setVenueName([])
    setIsPremium(false)
    setSearchInput("")
    setFollowupData({
      fromDate: today,
      toDate: today,
      leadNo:""
    })
    setSalesAgent([])
    setAgentKey(true)
    setTimeout(() => {
      setAgentKey(false)
    }, 0)
    // setIsRange(false)
    // setRangeValue([1, 1000000])
    dispatch(
      manageFollowupAction.loadManageFollowupList({
        page: 1,
        limit: 50,
        fromDate: today,
        toDate: today,
      })
    )
  }
  useEffect(() => {
    setTimeout(() => {
      if (applyFilter === false) {
        setFollowupData({
          ...followupData,
          fromDate: today,
          toDate: today,
        })
      }
    }, 3000)
  }, [applyFilter])
  const [pyramidModal, setPyramidModal] = useState(false)
  const [salesPyramidDetails, setSalesPyramidDetails] = useState()
  let slNo = 0
  const followupDataTable = !isEmpty(followup_details)
    ? followup_details.data.map((followupData, index) => {
      slNo = slNo + 1

      var followupDate = !isEmpty(followupData.followupDate)
        ? moment(followupData.followupDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      var leadDate = !isEmpty(followupData.leadDate)
        ? moment(followupData.leadDate)
          .subtract(5, "hours")
          .subtract(30, "minutes")
          .format(`${dateFormate} hh:mm A`)
        : []
      // aging and reassign difference
      const currentDay = moment().startOf("day")
      const createdDate = moment.utc(followupData.leadDate).startOf("day")
      const assignedDate = moment
        .utc(followupData.leadAssignDate)
        .startOf("day")

      const createdDifference =
        currentDay && createdDate
          ? currentDay.isValid() && createdDate.isValid()
            ? Math.ceil(currentDay.diff(createdDate, "days", true))
            : "--"
          : "--"
      const assignDifference =
        currentDay && assignedDate
          ? currentDay.isValid() && assignedDate.isValid()
            ? Math.ceil(currentDay.diff(assignedDate, "days", true))
            : "--"
          : "--"

      const dayDiffValue = `${createdDifference}/${assignDifference} days`
      const isBold = createdDifference > 60 ? true : false
      const eventDateVal = followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : ""
      const eventDate = followupData.eventDate ? moment(followupData.eventDate).startOf('day') : ""
      const followupDateValue = followupData.followupDate ? moment(followupData.followupDate).startOf('day') : ""
      const today = moment().startOf('day')
      const eventDateValue = eventDate ? eventDate.diff(today, 'days') : ""
      const followupCount = followupDateValue ? followupDateValue.diff(today, 'days') : ""
      const eventFollowup = eventDateValue && followupCount ?
        `${eventDateValue}/${followupCount}` : "--"
      const isSeason = !isEmpty(seasonDateValue) && !isEmpty(companySeasonId) &&
        seasonDateValue.some((m) => m === eventDateVal)
        && companySeasonId.some((m) => m === followupData.companyId)

      return {
        _id: followupData.leadId,
        sNo: slNo,
        clientName: followupData.clientName,
        venueName: followupData.venueName ? followupData.venueName : "--",
        venueLocation: followupData.venueLocation
          ? followupData.venueLocation
          : "--",
        isPremium: followupData.isPremium,
        action: (
          <Button
            type="submit"
            style={{ fontSize: "10px" }}
            className="btn btn-success buttons"
          >
            <i className="fas fa-pen icon-btn"></i>
          </Button>
        ),
        attachments: followupData.attachments,
        missedDaysCount: followupData.missedDaysCount,
        clientNo: followupData.clientNo,
        branchId: followupData.branchId,
        branchName: followupData.branchName,
        phoneNo: followupData.contact,
        leadNo: followupData.leadNo,
        companyId: followupData.companyId,
        clientPriority: followupData.priorityStatusName,
        session: followupData.session,
        followupDate: followupDate,
        salesUrge: followupData.salesUrge,
        leadAssign: followupData.leadAssign,
        budget: followupData.budget,
        followupStatus: followupData.followupStatus,
        processStatus: followupData.processStatusName,
        clientStatus: followupData.clientStatus,
        leadAssignArray: followupData.leadAssignArray,
        strategyRemark: followupData.strategyRemark,
        modeName: followupData.modeName === "OFFICE VISIT" ? "YES" : "NO",
        followupMode: followupData.modeName,
        visitDateTime:
          followupData.modeName === "OFFICE VISIT"
            ? moment(followupData.visitDateTime).format("DD-MM-YYYY hh:mm A")
            : "---",
        companyName: followupData.companyName,
        leadSourceName: followupData.leadSourceName,
        leadDate: leadDate,
        leadServiceName: followupData.leadServiceName,
        fromTime: followupData.fromTime,
        toTime: followupData.toTime,
        key: index,
        agingDate: dayDiffValue,
        actualAmount: followupData.actualAmount
          ? followupData.actualAmount
          : "--",
        discount: followupData.discount ? followupData.discount : "--",
        discountPercentage: followupData.discountPercentage
          ? Math.round(followupData.discountPercentage)
          : "--",
        totalValue: followupData.totalAmount
          ? followupData.totalAmount
          : "--",
        eventDate: followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : "--",
        currentFollowupDate: followupData.currentFollowupDate ? moment(followupData.currentFollowupDate).format(dateFormate) : "--",
        clientVisit: followupData.clientVisitCount,
        eventFollowupCount: eventFollowup,
        isGreenFlag: followupData.isGreenFlag,
        isSeason: isSeason,
        greenFlagRemarks: followupData.greenFlagremarks ? followupData.greenFlagremarks : "--",
        clientAppearanceRating: followupData.clientAppearanceRating ? `${followupData.clientAppearanceRating}  Ratings` : "--",
        salesPyramidHistory: followupData.salesPyramidHistory ? followupData.salesPyramidHistory : [],
        salesPyramid: followupData.salesPyramid ? followupData.salesPyramid : "--",
        leadSubStatus: followupData.leadSubStatus || "--",
        leadSource: followupData.leadSourceName || "--",
        leadService: followupData.leadServiceName ? followupData.leadServiceName : "--",
        eventServices: followupData.eventServices ? followupData.eventServices : "--",
        crossPromotion: followupData.crossPromotion ? followupData.crossPromotion : "--",
        followupCount: followupData.followupCount,
        isBold: isBold,
        zgClient: !isEmpty(followupData.zgPlusClient) ? followupData.zgPlusClient : [],
        averageFollowup: followupData.averageFollowup ? followupData.averageFollowup : "--",
        clientProfileName: followupData.clientProfileName ? followupData.clientProfileName : "--",
        clientProfileStatus: followupData.clientStatus ? followupData.clientStatus : "--",
        clientProfileRemarks: followupData.clientProfileRemarks ? followupData.clientProfileRemarks : "--",
        goodLookingClient:followupData.goodLookingClient,
        highEndClient:followupData.highEndClient
      }
    })
    : []
  const [followupHistoryModal, setFollowupHistoryModal] = useState(false)
  const handleFollowupHistoryModal = () => {
    setFollowupHistoryModal(false)
  }
  const handleFollowupSubmit = (data) => {
    const payload = {
      leadId: data
    }
    setFollowupHistoryModal(true)
    setTimeout(() => {
      dispatch(auditAction.loadFollowupHistory(payload))
    }, 500)
  }
  const handleZgClientSubmit = (data) => {
    const payload = {
      leadNo: data
    }
    setFollowupHistoryModal(true)
    setTimeout(() => {
      dispatch(auditAction.loadFollowupHistory(payload))
    }, 500)
  }
  //aging assigned api
  const agingAssigned = (row) => {
    setAgingModal(true)
    const assignData = {
      leadId: row._id,
    }
    setTimeout(() => {
      dispatch(manageFollowupAction.loadAssigned(assignData))
    }, 500)
  }
  const salesFollowupUpdate = useSelector(
    (specificstate) => specificstate.salesfollowup
  )
  const { followup_history = [] } = salesFollowupUpdate

  //pagination table data columns
  const initialColumns = [
    {
      dataField: "sNo",
      text: "S.No",
      hidden: false,
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
    },
    {
      dataField: "leadNo",
      text: "Lead No",
      hidden: false,
      style: (cell, row) => ({
        textTransform: "uppercase",
        color: "#e40d8c",
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "goodLookingClient",
      text: "Good Looking Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {   
         return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#FFD700",
                     backgroundColor: "#BF55EC"
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "highEndClient",
      text: "High End Client",
      hidden: false,
      editable: false,
      formatter: (cellContent) => {
        return (
          <Row>
            <Col md="8" lg="8" sm="8">
              <div style={{ textAlign: "center", justifyContent: "center" }}>

                {cellContent == true ? <span
                  className={"badge"}
                  style={{
                    display: "inline-block",
                    width: "35px",
                    height: "35px",
                    borderRadius: "50%",
                    color: "#BF55EC",
                      backgroundColor: "#FFD700"
                 
                  }}
                /> : "--"}
              </div>
            </Col>

          </Row>
        )


      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
      }),
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "clientNo",
      text: "Client Code",
      hidden: false,
      style: (cell, row) => ({
        textTransform: "uppercase",
        color: "#e40d8c",
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "125px",
      },
      // filter: textFilter()
    },
    {
      dataField: "clientAppearanceRating",
      text: "Client Appearance Rating",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "230px",
      },
    },
    {
      dataField: "clientProfileName",
      text: "Client Profile Name",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "clientProfileStatus",
      text: "Client Profile Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "clientProfileRemarks",
      text: "Client Profile Remarks",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "companyName",
      text: "Company",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "followupDate",
      text: "Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "session",
      text: "Session",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "100px",
      },
    },
    {
      dataField: "venueLocation",
      text: "Venue Location",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "venueName",
      text: "Venue Name",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "followupCount",
      text: "Followup Count",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "averageFollowup",
      text: "Average Followup",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "clientVisit",
      text: "Client Visit",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "135px",
      },
    },
    {
      dataField: "eventFollowupCount",
      text: "Event Date / Next Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "265px",
      },
    },
    {
      dataField: "isPremium",
      text: "Premium",
      formatter: (cellContent, row) => {
        return (
          <Badge
            color={row.isPremium === true ? "success" : "danger"}
            style={{ padding: "8px 14px", fontSize: "12px" }}
          >
            {" "}
            {row.isPremium == true ? "Yes" : "No"}
          </Badge>
        )
      },
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
    },
    {
      dataField: "salesUrge",
      text: "Sales Urge",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "actualAmount",
      text: "Actual Value",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "discount",
      text: "Discount",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "discountPercentage",
      text: "Discount Percentage",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "190px",
      },
    },
    {
      dataField: "budget",
      text: "Total Value / Budget",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "200px",
      },
    },

    {
      dataField: "processStatus",
      text: "Process Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "followupStatus",
      text: "Followup Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <Badge className="font-size-12 badge rounded-pill bg-danger badge-soft-danger">
            {row.followupStatus}
          </Badge>
        )
      },
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "missedDaysCount",
      text: "Missed Count",
      style: (cell, row) => ({

        color: "#e40d8c",
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "clientStatus",
      text: "Client Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "138px",
      },
    },

    {
      dataField: "modeName",
      text: "Office Visit",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "visitDateTime",
      text: "Office Visit Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      headerStyle: {
        minWidth: "155px",
      },
      hidden: false,
    },

    {
      dataField: "followupMode",
      text: "Follow Up Mode",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },

    {
      dataField: "leadAssign",
      text: "SalesAgent",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "phoneNo",
      text: "Mobile",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "155px",
      },
    },
    {
      dataField: "strategyRemark",
      text: "Strategy Remark",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "clientPriority",
      text: "Client Priority",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "160px",
      },

    },
    {
      dataField: "agingDate",
      text: "Aging/Re-assigning",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col xl="6" lg="6" md="6" sm="6" xs="6">
              {row.agingDate}
            </Col>
            <Col xl="5" lg="5" md="5" sm="5" xs="5">
              <div
                //className="mx-2"
                onClick={() => {
                  agingAssigned(row)
                }}
              >
                Aging
                <i
                  className="mx-2 fas fa-eye"
                  style={{ color: "#50a5f1", fontSize: "13px" }}
                ></i>
              </div>
            </Col>
          </Row>
          // <div className="d-flex flex-row">
          //   {row.agingDate}
          //   <div
          //     className="mx-2"
          //     onClick={() => {
          //       agingAssigned(row)
          //     }}
          //   >
          //     Aging
          //     <i
          //       className="mx-2 fas fa-eye"
          //       style={{ color: "#50a5f1", fontSize: "13px" }}
          //     ></i>
          //   </div>
          // </div>
        )
      },
      headerStyle: {
        minWidth: "270px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadSubStatus",
      text: "Lead Sub Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "salesPyramid",
      text: "Pyramid Status",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "eventServices",
      text: "Event Service",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "crossPromotion",
      text: "Cross Promotion",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadService",
      text: "Lead Service",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "leadSource",
      text: "Lead Source",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "currentFollowupDate",
      text: "Current Followup Date",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "195px",
      },
    },

    {
      dataField: "followupHistory",
      text: "Followup History",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      formatter: (cellContent, row) => {
        return (
          <Row>
            <Col md="6" lg="6" sm="6">
              {row.currentFollowupCount ? <div className="space-between">
                <span className="badge rounded-pill bg-primary">
                  {row.followupCount}
                </span>
              </div> : "--"}

            </Col>
            <Col md="4" lg="4" sm="4">
              <i
                className="fas fa-eye text-info fs-5"
                onClick={() => {

                  handleFollowupSubmit(row._id)
                }}
              ></i>
            </Col>
          </Row>

        )
      },
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "zgClient",
      text: "ZG + 1 Clients",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      formatter: (cellContent, row) => (
        !isEmpty(row.zgClient) ? (
          row.zgClient.map((client, index) => (
            <span
              key={index}
              onClick={() => handleZgClientSubmit(client)}
              style={{ cursor: "pointer", color: "#e83e8c", marginRight: "5px" }}
            >
              {client}{index < row.zgClient.length - 1 ? ", " : ""}
            </span>
          ))
        ) : "--"
      ),
      hidden: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    //ZG + 1 Clients
    {
      dataField: "salePyramid",
      text: "Sale Pyramid History",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      formatter: (cellContent, row) => {
        return (
          <div
            className="ms-auto ml-2"
            onClick={() => {
              setSalesPyramidDetails(row.salesPyramidHistory)
              setPyramidModal(true)
            }}
          >
            <i
              className="fas fa-eye"
              style={{ color: "#50a5f1", fontSize: "15px" }}
            ></i>
          </div>
        )
      },
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "greenFlagRemarks",
      text: "Green Flag Remarks",
      style: (cell, row) => ({
        backgroundColor: row.isSeason === true ? "#FFA500" : row.isGreenFlag === true ? "#3abd856e" : "",
        fontWeight: row.isBold === true ? "bold" : "normal",
      }),
      hidden: false,
      headerStyle: {
        minWidth: "185px",
      },
    },
  ]
  const [columns, setColumns] = useState(initialColumns)
  const [columnModal, setColumnModal] = useState(false)
  const [oddColumnData, setOddColumnData] = useState([])
  const [evenColumnData, setEvenColumnData] = useState([])
  useEffect(() => {
    if (columns && columns.length > 0) {
      var array = columns
      var evenColumns = []
      var oddColumns = []

      for (var i = 0; i < array.length; i++) {
        if (i % 2 === 0) {
          oddColumns.push(array[i])
        } else {
          evenColumns.push(array[i])
        }
      }

      setOddColumnData(oddColumns)
      setEvenColumnData(evenColumns)
    }
  }, [columns])

  const selectColumn = columns
    .filter((column) => column.hidden === false)
    .map((column) => column.dataField)

  const [selectedColumns, setSelectedColumns] = useState(selectColumn)

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target

    let updatedSelectedColumns
    if (checked) {
      updatedSelectedColumns = [...selectedColumns, value]
    } else {
      updatedSelectedColumns = selectedColumns.filter(
        (column) => column !== value
      )
    }

    setSelectedColumns(updatedSelectedColumns)
  }

  //  "Select All" checkbox
  const handleSelectAllChange = (e) => {
    const { checked } = e.target
    if (checked) {
      const allColumns = columns.map((column) => column.dataField)
      setSelectedColumns(allColumns)
    } else {
      const restoredColumns = initialColumns
        .filter((column) => !column.hidden)
        .map((column) => column.dataField)
      setSelectedColumns(restoredColumns)
    }
  }

  const handleSaveColumns = () => {
    setColumnModal(false)

    const updatedColumns = columns.map((column) => {
      const isColumnSelected = selectedColumns.includes(column.dataField)
      return { ...column, hidden: !isColumnSelected }
    })

    setColumns(updatedColumns)
    // default columns
    const defaultColumns = initialColumns.filter((column) => !column.hidden)
    const selectedNonDefaultColumns = selectedColumns.filter(
      (column) =>
        !defaultColumns.some(
          (defaultColumn) => defaultColumn.dataField === column
        )
    )

    if (selectedNonDefaultColumns.length > 0) {
      toast.success("New Columns added successfully!", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000,
      })
    }
  }

  const handleRestoreToDefault = () => {
    const restoreColumns = initialColumns
      .filter((column) => !column.hidden)
      .map((column) => column.dataField)

    setSelectedColumns(restoreColumns)
  }

  const clientStatusOptions = [
    {
      label: "VIP",
      value: "VIP",
    },
    {
      label: "VVIP",
      value: "VVIP",
    },
    {
      label: "OTHERS",
      value: "OTHERS",
    },
  ]

  const [loading, setLoading] = useState(false)
  const [searchInput, setSearchInput] = useState("")
  const [searchFilter, setSearchFilter] = useState(false)
  const handleClick = (e) => {
    setSearchFilter(true)
    e.preventDefault()
    dispatch(
      manageFollowupAction.loadManageFollowupList({
        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: 50,
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }

  //Pagination Component
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(priorityCode) ||
      !isEmpty(followupMode) ||
      !isEmpty(clientStatus) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate) ||
      !isEmpty(followupData.leadNo) ||
      !isEmpty(salesAgent)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchFollowup =
        followupMode && followupMode ? followupMode.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchClientStatus = !isEmpty(clientStatus) ? clientStatusValue : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""
          var searchLeadNo =
          followupData && followupData.leadNo
            ? followupData.leadNo
            : ""
          var searchAgent = !isEmpty(salesAgent) && salesAgent ? salesAgent.value : ""
      // var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
      // var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
      var searchVenue = venueName && venueName ? venueName.value : ""
      var searchPremium = isPremium
      var searchvalue = {}

      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchVenue) {
        searchvalue.venueId = searchVenue
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchFollowup) {
        searchvalue.mode = searchFollowup
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchClientStatus) {
        searchvalue.profileStatus = searchClientStatus
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchAgent) {
        searchvalue.salesAgentId  = searchAgent
      }
      // if (isRange) {
      //   if (searchFromRange) {
      //     searchvalue.fromRange = searchFromRange
      //   }
      //   if (searchToRange) {
      //     searchvalue.toRange = searchToRange
      //   }
      // }
      setPageLoad(!pageLoad)

      setDownloadLoading(true)
      api
        .post(`/get_future_followup_list_excel_export`, searchvalue)
        .then((response) => {
          const followupExportDataTable = !isEmpty(response.data.data)
            ? response.data.data.map((followupData, index) => {
              // serialNo = serialNo + 1

              var followupDate = !isEmpty(followupData.followupDate)
                ? moment(followupData.followupDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(`${dateFormate} hh:mm A`)
                : []
              var leadDate = !isEmpty(followupData.leadDate)
                ? moment(followupData.leadDate)
                  .subtract(5, "hours")
                  .subtract(30, "minutes")
                  .format(`${dateFormate} hh:mm A`)
                : []

              const venueName = followupData.venueName
                ? followupData.venueName
                : ""
              const venueNameValue =
                !isEmpty(venueName) && venueName != ","
                  ? JSON.stringify(venueName).replace(/","/g, "\n")
                  : "--"

              const venueLocation = followupData.venueLocation
                ? followupData.venueLocation
                : ""
              const venueLocationValue =
                !isEmpty(venueLocation) && venueLocation != ","
                  ? JSON.stringify(venueLocation).replace(/","/g, "\n")
                  : "--"
              const strategyRemark = !isEmpty(followupData.strategyRemark)
                ? followupData.strategyRemark
                : ""
              const strategyRemarkValue = !isEmpty(strategyRemark)
                ? strategyRemark.replace(/[\r\n,.]/gm, "")
                : "--"
              const isPremium = followupData.isPremium === true ? "Yes" : "No"
              // aging and reassign difference
              const currentDay = moment().startOf("day")
              const createdDate = moment
                .utc(followupData.leadDate)
                .startOf("day")
              const assignedDate = moment
                .utc(followupData.leadAssignDate)
                .startOf("day")

              const createdDifference =
                currentDay && createdDate
                  ? currentDay.isValid() && createdDate.isValid()
                    ? Math.ceil(currentDay.diff(createdDate, "days", true))
                    : "--"
                  : "--"
              const assignDifference =
                currentDay && assignedDate
                  ? currentDay.isValid() && assignedDate.isValid()
                    ? Math.ceil(currentDay.diff(assignedDate, "days", true))
                    : "--"
                  : "--"
              const dayDiffValue = `${createdDifference}/${assignDifference} days`
              const eventDate = followupData.eventDate ? moment(followupData.eventDate).startOf('day') : ""
              const followupDateValue = followupData.followupDate ? moment(followupData.followupDate).startOf('day') : ""
              const today = moment().startOf('day')
              const eventDateValue = eventDate ? eventDate.diff(today, 'days') : ""

              const followupCount = followupDateValue ? followupDateValue.diff(today, 'days') : ""
              const eventFollowup = eventDateValue && followupCount ?
                `="${eventDateValue}/${followupCount}"` : "--"
              const zgClient = !isEmpty(followupData.zgPlusClient) ? followupData.zgPlusClient.map(m => m).join(",") : "--"
              const zgClientValue =
                !isEmpty(zgClient) && zgClient != ","
                  ? JSON.stringify(zgClient).replace(/","/g, "\n")
                  : "--"
              const clientProfileRemarksValue = !isEmpty(followupData.clientProfileName)
                ? JSON.stringify(followupData.clientProfileName).replace(/","/g, "\n")
                : "--"
              return {
                _id: followupData.leadId,
                sNo: index + 1,
                clientName: followupData.clientName,
                attachments: followupData.attachments,
                missedDaysCount: followupData.missedDaysCount
                  ? followupData.missedDaysCount
                  : "--",
                clientNo: followupData.clientNo,
                venueName: venueNameValue,
                venueLocation: venueLocationValue,
                isPremium: isPremium,
                branchId: followupData.branchId,
                branchName: followupData.branchName
                  ? followupData.branchName
                  : "--",
                phoneNo: followupData.contact ? followupData.contact : "--",
                leadNo: followupData.leadNo,
                companyId: followupData.companyId,
                clientPriority: followupData.priorityStatusName
                  ? followupData.priorityStatusName
                  : "--",
                session: followupData.session ? followupData.session : "--",
                followupDate: followupDate,
                salesUrge: followupData.salesUrge
                  ? followupData.salesUrge
                  : "--",
                leadAssign: followupData.leadAssign
                  ? followupData.leadAssign
                  : "--",
                budget: followupData.budget ? followupData.budget : "--",
                followupStatus: followupData.followupStatus,
                processStatus: followupData.processStatusName,
                clientStatus: followupData.clientStatus,
                strategyRemark: strategyRemarkValue,
                modeName:
                  followupData.modeName === "OFFICE VISIT" ? "YES" : "NO",
                followupMode: followupData.modeName,
                visitDateTime:
                  followupData.modeName === "OFFICE VISIT"
                    ? moment(followupData.visitDateTime).format(
                      "DD-MM-YYYY hh:mm A"
                    )
                    : "---",
                companyName: followupData.companyName,
                leadSourceName: followupData.leadSourceName,
                leadDate: leadDate,
                leadServiceName: followupData.leadServiceName,
                fromTime: followupData.fromTime,
                toTime: followupData.toTime,
                agingDate: dayDiffValue,
                key: index,
                currentFollowupDate: followupData.currentFollowupDate ? moment(followupData.currentFollowupDate).format(dateFormate) : "--",
                actualAmount: followupData.actualAmount
                  ? followupData.actualAmount
                  : "--",
                discount: followupData.discount
                  ? followupData.discount
                  : "--",
                discountPercentage: followupData.discountPercentage
                  ? Math.round(followupData.discountPercentage)
                  : "--",
                totalValue: followupData.totalAmount
                  ? followupData.totalAmount
                  : "--", 
                eventDate: followupData.eventDate ? moment(followupData.eventDate).format(dateFormate) : "--",
                followupCount: followupData.followupCount ? followupData.followupCount : "--",
                clientVisit: followupData.clientVisitCount,
                eventFollowupCount: eventFollowup,
                greenFlagRemarks: followupData.greenFlagremarks ? followupData.greenFlagremarks : "--",
                salesPyramid: followupData.salesPyramid ? followupData.salesPyramid : "--",
                leadSubStatus: followupData.leadSubStatus || "--",
                leadSource: followupData.leadSourceName ? followupData.leadSourceName : "--",
                leadService: followupData.leadServiceName ? followupData.leadServiceName : "--",
                eventServices: followupData.eventServices ? followupData.eventServices : "--",
                crossPromotion: followupData.crossPromotion ? followupData.crossPromotion : "--",
                zgClient: zgClientValue,
                clientProfileName: followupData.clientProfileName ? followupData.clientProfileName : "--",
                clientProfileStatus: followupData.clientStatus ? followupData.clientStatus : "--",
                clientProfileRemarks: clientProfileRemarksValue,
                averageFollowup: followupData.averageFollowup ? followupData.averageFollowup : "--",
                goodLookingClient:followupData.goodLookingClient == true ? "YES" : "NO",
                highEndClient:followupData.highEndClient == true ? "YES" : "NO",
                clientAppearanceRating: followupData.clientAppearanceRating ? `${followupData.clientAppearanceRating}  Ratings` : "--"
              }
            })
            : []
          setTimeout(() => {
            let headerData = [
              "SNo,Lead No,Good Looking Client,High End CLient, Client No,Client Appearance Rating,Client Profile Name,Client Profile Status, Client profile Remarks,Company Name, Branch Name, Followup Date,Session,Venue Location, Venue Name,Event Date, Followup Count,Average Followup,Client Visit,Event Date / Next Followup Date,Premium,Sales Urge,Actual Value,Discount, Discount Percentage,Total Value / Budget,Process Status, Followup Status,Missed Count,Client Status, Mode Name, Visit DateTime,Followup Mode, Client Name,Lead Assign,PhoneNo, Strategy Remark, Client Priority,Current Followup Date,Aging/Re-assigning,Lead Date,Lead Sub Status,Pyamid Status,Event Services,Cross Promotion,Lead Service, Lead Source,ZG + 1 Clients,Green Flag Remarks",
            ]

            let usersCsv =
              !isEmpty(followupExportDataTable) &&
              followupExportDataTable.reduce((acc, user) => {
                const {
                  sNo,
                  leadNo,
                  goodLookingClient,
                  highEndClient,
                  clientNo,
                  clientAppearanceRating,
                  clientProfileName,
                  clientProfileRemarks,
                  clientProfileStatus,
                  companyName,
                  branchName,
                  followupDate,
                  session,
                  venueLocation,
                  venueName,
                  eventDate,
                  followupCount,
                  averageFollowup,
                  clientVisit,
                  eventFollowupCount,
                  isPremium,
                  salesUrge,
                  actualAmount,
                  discount,
                  discountPercentage,
                  budget,
                  processStatus,
                  followupStatus,
                  missedDaysCount,
                  clientStatus,
                  modeName,
                  visitDateTime,
                  followupMode,
                  clientName,
                  leadAssign,
                  phoneNo,
                  strategyRemark,
                  clientPriority,
                  currentFollowupDate,
                  agingDate,
                  leadDate,
                  leadSubStatus,
                  salesPyramid,
                  eventServices,
                  crossPromotion,
                  leadService,
                  leadSource,
                  zgClient,
                  greenFlagRemarks
                } = user
                acc.push([
                  sNo,
                  leadNo,
                  goodLookingClient,
                  highEndClient,
                  clientNo,
                  clientAppearanceRating,
                  clientProfileName,
                  clientProfileRemarks,
                  clientProfileStatus,
                  companyName,
                  branchName,
                  followupDate,
                  session,
                  venueLocation,
                  venueName,
                  eventDate,
                  followupCount,
                  averageFollowup,
                  clientVisit,
                  eventFollowupCount,
                  isPremium,
                  salesUrge,
                  actualAmount,
                  discount,
                  discountPercentage,
                  budget,
                  processStatus,
                  followupStatus,
                  missedDaysCount,
                  clientStatus,
                  modeName,
                  visitDateTime,
                  followupMode,
                  clientName,
                  leadAssign,
                  phoneNo,
                  strategyRemark,
                  clientPriority,
                  currentFollowupDate,
                  agingDate,
                  leadDate,
                  leadSubStatus,
                  salesPyramid,
                  eventServices,
                  crossPromotion,
                  leadService,
                  leadSource,
                  zgClient,
                  greenFlagRemarks
                ])

                return acc
              }, [])

            downloadFile({
              data: [...headerData, ...usersCsv].join("\n"),
              fileName: "manageFollowup.csv",
              fileType: "text/csv",
            })
            setDownloadLoading(false)
          }, 2500)
          return response.data
        })
        .catch((error) => {
          Promise.reject(error)
          setDownloadLoading(false)
        })
    }
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      {/* {downloadAccessId === "61bc3079e2e60e9919697604" ? ( */}
                      <Col md="8" style={{ marginBottom: "20px", marginTop: "-41px" }}>

                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >

                       <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                              marginRight: "10px",
                            }}
                          >
                            Download
                          </Button>
                          <Button
                            className="btn btn-info"
                            onClick={() => setColumnModal(true)}
                          >
                            Edit Columns
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          // {...props.baseProps}
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          noDataIndication={"No Data Found..."}
                          responsive
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone
                            // paginationTotalRenderer={leave_list.totalDataCount}
                            {...paginationProps}
                          />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: followup_details.length,
    data:
      !isEmpty(followup_details) && followup_details.length > 0
        ? followup_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(followup_details) && followup_details.length > 0
        ? followup_details
        : []
    if (
      !isEmpty(companies) ||
      !isEmpty(branches) ||
      !isEmpty(priorityCode) ||
      !isEmpty(followupMode) ||
      !isEmpty(clientStatus) ||
      !isEmpty(followupData.fromDate) ||
      !isEmpty(followupData.toDate)  ||
      !isEmpty(followupData.leadNo) ||
      !isEmpty(salesAgent)
    ) {
      var searchCompany = companies && companies ? company : ""
      var searchBranch = branches && branches ? branch : ""
      var searchFollowup =
        followupMode && followupMode ? followupMode.value : ""
      var searchPriority = priorityCode && priorityCode ? priority : ""
      var searchClientStatus = !isEmpty(clientStatus) ? clientStatusValue : ""
      var searchFromDate =
        followupData && followupData.fromDate
          ? moment(followupData.fromDate).format("YYYY-MM-DD")
          : ""
      var searchToDate =
        followupData && followupData.toDate
          ? moment(followupData.toDate).format("YYYY-MM-DD")
          : ""
          var searchLeadNo =
          followupData && followupData.leadNo
            ? followupData.leadNo
            : ""
          var searchAgent = !isEmpty(salesAgent) && salesAgent ? salesAgent.value : ""
      // var searchFromRange = !isEmpty(rangeValue) ? rangeValue[0] : ""
      // var searchToRange = !isEmpty(rangeValue) ? rangeValue[1] : ""
      var searchVenue = venueName && venueName ? venueName.value : ""
      var searchPremium = isPremium
      var searchvalue = {}
      searchvalue.page = page
      searchvalue.limit = sizePerPage ? sizePerPage : 50
      if (searchCompany) {
        searchvalue.companyId = searchCompany
      }
      if (searchPremium) {
        searchvalue.isPremium = searchPremium
      }
      if (searchVenue) {
        searchvalue.venueId = searchVenue
      }
      if (searchBranch) {
        searchvalue.branchId = searchBranch
      }
      if (searchFollowup) {
        searchvalue.mode = searchFollowup
      }
      if (searchPriority) {
        searchvalue.priorityId = searchPriority
      }
      if (searchClientStatus) {
        searchvalue.profileStatus = searchClientStatus
      }
      if (searchFromDate) {
        searchvalue.fromDate = searchFromDate
      }
      if (searchToDate) {
        searchvalue.toDate = searchToDate
      }
      if (searchLeadNo) {
        searchvalue.leadNo = searchLeadNo
      }
      if (searchAgent) {
        searchvalue.salesAgentId  = searchAgent
      }
      // if (isRange) {
      //   if (searchFromRange) {
      //     searchvalue.fromRange = searchFromRange
      //   }
      //   if (searchToRange) {
      //     searchvalue.toRange = searchToRange
      //   }
      // }
      setPageLoad(!pageLoad)

      setLoading(true)
      specificDispatch(manageFollowupAction.loadManageFollowupList(searchvalue))
    } else {
      specificDispatch(
        manageFollowupAction.loadManageFollowupList({
          page: page,
          limit: sizePerPage,
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs title={"Sales"} breadcrumbItem={title} />

          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="company"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            manageFollowupMetaData
                              ? manageFollowupMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branch"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Followup Mode"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="followupMode"
                          value={followupMode}
                          onChange={(e) => setFollowupMode(e)}
                          options={
                            manageFollowupMetaData
                              ? manageFollowupMetaData.followupModeOptions
                              : []
                          }
                          placeholder="Select Followup"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Priority"}
                          </Label>
                        </div>
                        <Select
                          name="priorityCode"
                          value={priorityCode}
                          onChange={(e) => setPriorityCode(e)}
                          isMulti
                          options={
                            manageFollowupMetaData
                              ? manageFollowupMetaData.priorityOptions
                              : []
                          }
                          placeholder="Select Priority"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Followup From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={followupData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>

                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"To Date"}>
                            {"Followup To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={followupData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Client Status"}
                          </Label>
                        </div>
                        <Select
                          name="clientStatus"
                          value={clientStatus}
                          onChange={(e) => setClientStatus(e)}
                          isMulti
                          options={clientStatusOptions}
                          placeholder="Select Client Status"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Venue"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="venueName"
                          value={venueName}
                          // isMulti
                          onChange={(e) => setVenueName(e)}
                          options={
                            manageFollowupMetaData
                              ? manageFollowupMetaData.venueOptions
                              : []
                          }
                          placeholder="Select Venue"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"From Date"}>
                            {"Lead No"}
                          </Label>
                        </div>
                        <Input
                          type="text"
                          placeholder="Enter Lead No"
                          name="leadNo"
                          value={followupData.leadNo}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className="form-label" htmlFor={"CRM Name"}>
                            {"Sales Agent"}
                          </Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="agent"
                          key={agentKey}
                          items={manageFollowupMetaData.employeeOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          onClear={() => setSalesAgent([])}
                          placeholder="Enter Sales Agent"
                          fuseOptions={fuseAgentOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="3" xs="3" className="mt-4">
                        <div className="d-flex flex-row">
                          {statusList.map((status, index) => {
                            return (
                              <div className="d-flex flex-row" key={index}>
                                <Input
                                  type="checkbox"
                                  name="isPremium"
                                  value={status.value}
                                  checked={isPremium === status.value}
                                  // className={status.value ? "audit-status-border" : ""}
                                  onChange={(e) =>
                                    handleStatusChange(e, status.value)
                                  }
                                  className="font-size-15"
                                />
                                <Label
                                  className="mx-2"
                                  style={{ marginTop: "2px", fontSize: "12px" }}
                                >
                                  {status.label}
                                </Label>
                              </div>
                            )
                          })}
                        </div>
                      </Col>

                      {/* <Col lg="6" md="6" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Budget Range"}</Label>
                        </div>
                        <div className="d-flex justify-content-center align-items-center mb-4">
                          <div className="d-flex align-items-center me-3">
                            <span className="me-2">Min</span>
                            <InputNumber
                              min={0}
                              max={rangeValue[1]}
                              value={rangeValue[0]}
                              onChange={handleMinChange}
                              placeholder="Min"
                            />
                          </div>


                          <span className="mx-2">-</span>

                          <div className="d-flex align-items-center">
                            <span className="me-2">Max</span>
                            <InputNumber
                              min={rangeValue[0]}
                              max={1000000}
                              value={rangeValue[1]}
                              onChange={handleMaxChange}
                              placeholder="Max"
                            />
                          </div>
                        </div>
                        <Slider range
                          min={0}
                          max={1000000}
                          value={rangeValue}
                          onChange={handleRangeChange}
                        />
                      </Col> */}
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-4">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => handleFilter(e)}
                            className="mx-2 btn btn-success btn-label simple-form-applyfilter-btn"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {/*Table start*/}
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <Button
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#2ca67a" : "",
                          }}
                          className="btn btn-success mx-2"
                        >
                          <i className="fas fa-search"></i>
                        </Button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={followupDataTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={followup_details.totalDataCount}
                    onTableChange={handleTableChange}
                  />
                  {agingModal && (
                    <Modal size="xl" show={agingModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Aging
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales Agent Code</th>
                                <th>Sales Agent Name</th>
                                <th>Created Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {!isEmpty(assign_details) &&
                                assign_details.length > 0 ? (
                                assign_details.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{data.assignedEmployeeCode}</td>
                                      <td>{data.assignedEmployeeName}</td>
                                      <td>
                                        {moment(data.createdAt).format(
                                          "DD-MM-YYYY"
                                        )}
                                      </td>
                                    </tr>
                                  )
                                })
                              ) : (
                                <tr key={0}>
                                  <td className="text-align-center" colSpan={4}>
                                    No Records Found...
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setAgingModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {pyramidModal && (
                    <Modal size="xl" show={pyramidModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Sale Pyramid History
                      </Modal.Header>
                      <Modal.Body>
                        <Row className="mt-3">
                          <Table>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th>Sales Pyramid Status</th>
                                <th>Created By Name</th>
                                <th>Created Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              {salesPyramidDetails && !isEmpty(salesPyramidDetails) ?
                                salesPyramidDetails.map((data, index) => {
                                  return (
                                    <tr key={index}>
                                      <td>{index}</td>
                                      <td>{data.salesPyramid ? data.salesPyramid : "--"}</td>
                                      <td>{data.salesPyramidOn ? moment(data.salesPyramidOn).format(dateFormate) : "--"}</td>
                                      <td>{data.salesPyramidByName ? data.salesPyramidByName : "--"}</td>
                                    </tr>
                                  )
                                })
                                : <tr key={0}>
                                  <td className="text-align-center" colSpan={4}>
                                    No Records Found...
                                  </td>
                                </tr>}

                            </tbody>
                          </Table>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => setPyramidModal(false)}
                        >
                          Close
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {columnModal && (
                    <Modal size="xl" show={columnModal}>
                      <Modal.Header
                        style={{
                          backgroundColor: "white",
                          color: "black",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        Edit Columns
                        <span>
                          <i
                            className="fa fa-times quote-close"
                            aria-hidden="true"
                            onClick={() => setColumnModal(false)}
                          ></i>
                        </span>
                      </Modal.Header>
                      <Modal.Body>
                        <Row>
                          <div>
                            <Input
                              type="checkbox"
                              checked={
                                selectedColumns.length === columns.length
                              }
                              onChange={(e) => handleSelectAllChange(e)}
                              style={{ width: "15px", height: "15px" }}
                            />
                            <Label
                              style={{ fontSize: "16px", marginLeft: "10px" }}
                            >
                              Select All
                            </Label>
                          </div>
                        </Row>
                        <Row>
                          <Col sm="12" md="6" lg="6" className="ml-4">
                            {oddColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                          <Col sm="12" md="6" lg="6">
                            {evenColumnData.map((column) => (
                              <div
                                key={column.dataField}
                                className="d-flex flex-row"
                              >
                                <div className="form-check form-check-inline">
                                  <Input
                                    type="checkbox"
                                    value={column.dataField}
                                    checked={selectedColumns.includes(
                                      column.dataField
                                    )}
                                    onChange={(e) => handleCheckboxChange(e)}
                                    style={{ width: "15px", height: "15px" }}
                                  />
                                  <Label
                                    style={{
                                      fontSize: "16px",
                                      marginLeft: "10px",
                                    }}
                                  >
                                    {column.text}
                                  </Label>
                                </div>
                              </div>
                            ))}
                          </Col>
                        </Row>
                      </Modal.Body>

                      <Modal.Footer>
                        <p
                          className="text-decoration-underline text-info"
                          style={{ cursor: "pointer", fontSize: "16px" }}
                          onClick={handleRestoreToDefault}
                        >
                          Restore To Default
                        </p>
                        <Button
                          variant="secondary"
                          className="btn btn-danger"
                          data-bs-dismiss="modal"
                          onClick={() => {
                            setColumnModal(false)
                            setSelectedColumns(selectColumn)
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          variant="primary"
                          className="btn btn-success"
                          onClick={() => handleSaveColumns()}
                        >
                          Submit
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  )}
                  {loading ? (
                    <Modal
                      show={loading}
                      style={{ width: "6.7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {btnLoading ? (
                    <Modal
                      show={btnLoading}
                      style={{ width: "6.7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {downloadLoading ? (
                    <Modal
                      show={downloadLoading}
                      style={{ width: "6.7%", margin: "18% 50%" }}
                    >
                      <Modal.Body>
                        <Spinner
                          as="span"
                          animation="grow"
                          size="lg"
                          role="status"
                          aria-hidden="true"
                          variant="success"
                          className="mx-2"
                          color="success"
                        />
                        {/* <span>Loading...</span> */}
                      </Modal.Body>
                    </Modal>
                  ) : (
                    ""
                  )}
                  {followupHistoryModal && (
                    <Modal show={followupHistoryModal} onHide={handleFollowupHistoryModal} size="lg">
                      <Modal.Header
                        style={{
                          backgroundColor: "#E40D8C",
                          color: "white",
                          minHeight: "65px",
                          fontSize: "16px",
                          fontWeight: "600",
                        }}
                      >
                        <Col
                          xl="6"
                          lg="6"
                          md="6"
                          sm="6"
                          xs="6"
                          className="d-flex flex-row"
                        >
                          <span>Followup History</span>
                          {/* <h1 className="request-header mx-2">{requestNo}</h1> */}
                        </Col>
                      </Modal.Header>
                      <Modal.Body>

                        <Col xl="12" lg="12" md="12" sm="12" xs="12" className="mt-2">

                          <Table responsive>
                            <thead>
                              <tr>
                                <th>S.No</th>
                                <th >Followup Status</th>
                                <th >Followup Date</th>
                                <th >Followup No</th>
                                <th >Followup Mode</th>
                                <th >Followup Remarks</th>
                                <th >Followup Attachment</th>
                                <th>Future Followup Date</th>
                                <th>Future Followup Mode</th>
                                {/* <th>Future Followup Remarks</th> */}
                                <th>Future Followup Strategy</th>
                                <th>Strategy Remark</th>
                              </tr>
                            </thead>
                            <tbody>
                              {followup_history && !isEmpty(followup_history) ?
                                followup_history.map((item, index) => {

                                  const attachment = !isEmpty(item.recordAttachment)
                                    ? item.recordAttachment[0]
                                    : ""
                                  const attachExtension = !isEmpty(attachment)
                                    ? attachment.split(".").pop()
                                    : ""
                                  const futureFollowupStrategyName = !isEmpty(item.futureFollowupStrategyName) ?
                                    item.futureFollowupStrategyName.map(m => m).join(",") : "--"


                                  const futureFollowupmodeName = !isEmpty(item.futureFollowupmodeName) ?
                                    item.futureFollowupmodeName.map(m => m).join(",") : "--"

                                  const followupStatusName = !isEmpty(item.followupStatusName) ?
                                    item.followupStatusName.map(m => m).join(",") : "--"
                                  return (
                                    <tr key={index}>
                                      <td>{index + 1}</td>
                                      <td>{followupStatusName}</td>
                                      <td>{item.followupDate ? moment(item.followupDate).format(dateFormate) : "--"}</td>
                                      <td>{item.followwupNo ? item.followwupNo : "--"}</td>
                                      <td>{item.modeName ? item.modeName : "--"}</td>
                                      <td>{item.remarks ? item.remarks : "--"}</td>
                                      <td>
                                        {" "}
                                        {(attachment &&
                                          attachExtension === "jpeg") ||
                                          (attachment &&
                                            attachExtension === "jpg") ||
                                          (attachment &&
                                            attachExtension === "png") ? (
                                          <div className="d-flex flex-row align-items-center">
                                            <a
                                              onClick={() =>
                                                window.open(
                                                  attachment,
                                                  "_blank"
                                                )
                                              }
                                            >
                                              <span
                                                style={{
                                                  textDecoration: "underline",
                                                  color: "#E40D8C",
                                                }}
                                              >
                                                View
                                              </span>
                                            </a>

                                          </div>
                                        ) : (attachment &&
                                          attachExtension === "mp3") ||
                                          (attachment &&
                                            attachExtension === "m4a") ||
                                          (attachment &&
                                            attachExtension === "mp4") ? (
                                          <a href={attachment}>
                                            <audio controls>
                                              <source
                                                src={attachment}
                                                type="audio/mpeg"
                                              />
                                              Your browser does not support the
                                              audio element.
                                            </audio>
                                          </a>
                                        ) : (
                                          "--"
                                        )}
                                      </td>
                                      <td>{item.futurefollowupDate ? moment(item.futurefollowupDate).format(dateFormate) : "--"}</td>
                                      <td>{futureFollowupmodeName}</td>
                                      {/* //   <td>{item.futureFollowupRemarks ? item.futureFollowupRemarks : "--"}</td> */}
                                      <td>{futureFollowupStrategyName}</td>
                                      <td>{item.strategyRemark ? item.strategyRemark : "--"}</td>
                                    </tr>)

                                }) :
                                <tr>
                                  <td className="text-align-center" colSpan={11}>
                                    No Records Found...
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </Table>
                        </Col>
                      </Modal.Body>
                      <Modal.Footer>
                        <div className="d-flex flex-row">
                          <Button
                            variant="secondary"
                            className="btn btn-danger"
                            onClick={handleFollowupHistoryModal}
                          >
                            Close
                          </Button>

                        </div>
                      </Modal.Footer>
                    </Modal>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ToastContainer
          position="top-right"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </React.Fragment>
  )
}

ManageFollowup.propTypes = {
  dispatch: PropTypes.func,
  recordsMetaData: PropTypes.array,
  searchProps: PropTypes.func,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  baseProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  csvProps: PropTypes.any,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  // employee: state.employeeRequest.employee,
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageFollowup)
)
